<template>
    <div>
        <BaseModal
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="editMode ? $t('therapyDlg.EditBillInfo') : $t('therapyDlg.AddBillInfo')"
            :width="'75%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
            ]"
            @Close="close"
        >
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('Shared.Active')"
                        v-bind:Name="'checkbox-isactive'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="'A'"
                        v-bind:UncheckedValue="'I'"
                        v-model="item.status"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.insuranceCode"
                        v-bind:ModelDescription="item.insuranceCode"
                        v-bind:Label="$tc('Insurance.Insurance')"
                        v-bind:RefCode="'insuranceCode'"
                        v-bind:Api="'Insurances'"
                        v-bind:FieldCode="'insurancecode'"
                        v-bind:FieldDescription="'company'"
                        v-bind:Fields="baseFieldsIns"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'InsuranceCode'"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Shared.StartDate')"
                        :Model="item.startDate"
                        @input="item.startDate = $event"
                        :Id="'billstartDate'"
                        :Type="'date'"
                        :isConfirm="false"
                        :ReadOnly="false"
                    >
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Shared.EndDate')"
                        :Model="item.endDate"
                        @input="item.endDate = $event"
                        :Id="'billendDate'"
                        :Type="'date'"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isValidDate"
                    >
                    </MdDateTime>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.cpt"
                        v-bind:ModelDescription="item.cpt"
                        v-bind:Label="$t('Shared.CPT')"
                        v-bind:RefCode="'cpt'"
                        v-bind:Api="'cpts?typeList=1&typeList=3&typeList=5'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'code'"
                        :SearchTitle="$t('Shared.CPT')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                        :isRequired="true"
                        :isValid="isCPTValid"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.hcPcsCode"
                        v-bind:ModelDescription="item.hcPcsCode"
                        v-bind:Label="$t('Shared.HCPCS')"
                        v-bind:RefCode="'hcpcs'"
                        v-bind:Api="'cpts?typeList=2&typeList=5'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'code'"
                        :SearchTitle="$t('Shared.HCPCS')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.modifier1"
                        v-bind:ModelDescription="item.modifier1"
                        v-bind:Label="$t('PatientClaimList.Modifier', { num: 1 })"
                        v-bind:RefCode="'modifiers1'"
                        v-bind:Api="'modifiers'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'code'"
                        :SearchTitle="$t('modifiersList.Modifiers')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                        v-bind:Fields="baseFieldsModifier"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.modifier2"
                        v-bind:ModelDescription="item.modifier2"
                        v-bind:Label="$t('PatientClaimList.Modifier', { num: 2 })"
                        v-bind:RefCode="'modifiers2'"
                        v-bind:Api="'modifiers'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$t('modifiersList.Modifiers')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                        v-bind:Fields="baseFieldsModifier"
                    />
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.modifier3"
                        v-bind:ModelDescription="item.modifier3"
                        v-bind:Label="$t('PatientClaimList.Modifier', { num: 3 })"
                        v-bind:RefCode="'modifiers3'"
                        v-bind:Api="'modifiers'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$t('modifiersList.Modifiers')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                        v-bind:Fields="baseFieldsModifier"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.modifier4"
                        v-bind:ModelDescription="item.modifier4"
                        v-bind:Label="$t('PatientClaimList.Modifier', { num: 4 })"
                        v-bind:RefCode="'modifiers4'"
                        v-bind:Api="'modifiers'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$t('modifiersList.Modifiers')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                        v-bind:Fields="baseFieldsModifier"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.valueCode"
                        v-bind:ModelDescription="item.valueCode"
                        v-bind:Label="$t('Shared.ValueCode')"
                        v-bind:RefCode="'valCode'"
                        v-bind:Fields="ValCodeFields"
                        v-bind:Api="'valuecodes'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'shortDescription'"
                        :SearchTitle="$t('Shared.ValueCode')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdLookup
                        v-bind:ModelCode="item.pos"
                        v-bind:ModelDescription="item.pos"
                        v-bind:Label="$t('Shared.POfService')"
                        v-bind:RefCode="'pos'"
                        v-bind:Api="'PlaceOfServices'"
                        v-bind:FieldCode="'code'"
                        v-bind:FieldDescription="'description'"
                        :SearchTitle="$t('Shared.POfService')"
                        :GetValues="onCodeConditionOk"
                        :SearchFieldCode="'Code'"
                    />
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('dcsview.Rate')"
                        v-bind:Name="'Rate'"
                        v-bind:TypeProp="'number'"
                        v-model="item.rateAmt"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-bind:Max="'10'"
                        v-bind:Id="'input_rate'"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('therapyDlg.BlankAuth')"
                        v-bind:TypeProp="'text'"
                        v-bind:Name="'priorAuthorization'"
                        v-bind:Max="'10'"
                        v-model="item.priorAuthorization"
                        v-bind:Id="'input_rate'"
                    >
                    </MdEdit>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdEdit
                        v-bind:Label="$t('PatientClaimList.Amtapproved')"
                        v-bind:Name="'approvedAmt'"
                        v-bind:TypeProp="'number'"
                        v-model="item.approvedAmt"
                        v-bind:Min="'0'"
                        v-bind:StepProp="'1'"
                        v-bind:Max="'10'"
                        v-bind:Id="'input_approvedAmt'"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('therapyDlg.IsNoC')"
                        v-bind:Name="'checkbox-covered'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="item.isNonCovered"
                    />
                </b-col>
            </b-row>
            <!--
            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('therapyDlg.UsPatCoP')"
                        v-bind:Name="'checkbox-copay'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="item.useCoPay"
                    />
                </b-col>
                <!- - <b-col lg="3" md="3" sm="12">
                    <MdCheckBox
                        v-bind:Label="$t('therapyDlg.FollD')" 
                        v-bind:Name="'checkbox-checkin'"
                        v-bind:ClassProp="'AlignCheck'"
                        v-bind:CheckedValue="true"
                        v-bind:UncheckedValue="false"
                        v-model="item.followDriverCheckIn"                     
                    />
                </b-col> - ->
            </b-row>
            -->
        </BaseModal>
    </div>
</template>

<script>
import Utils from '@/common/utils';
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';
import InsuranceService from '@/services/insurance.service';
import CptService from '@/services/cpt.service';
import ModifierService from '@/services/modifier.service';
import ValueCodeService from '@/services/valuescodes.service';
import PlaceOfServiceService from '@/services/placeofservice.service';
import ProviderService from '@/services/provider.service';
import moment from 'moment';

export default {
    name: 'therapyBillingEditDlg',
    mixins: [validationMixin, ShowMessage],

    props: {
        value: Object,
        visible: {
            type: Boolean,
            default: false
        },
        baseFieldsIns: Array,
        baseFieldsModifier: Array,
        checkOverlapping: {
            type: Function,
            required: true
        }
    },

    data() {
        const defaultValue = {
            insuranceName: '',
            insuranceCode: null,
            startDate: null,
            endDate: null,
            recordId: '',
            status: 'A',
            cpt: null,
            dcpt: '',
            hcPcsCode: null,
            dhcpcs: '',
            modifier1: null,
            dmodifier1: '',
            modifier2: null,
            dmodifier2: '',
            modifier3: null,
            dmodifier3: '',
            modifier4: null,
            dmodifier4: '',
            valueCode: null,
            dvalCode: '',
            pos: null,
            dpos: '',
            rateAmt: 0,
            priorAuthorization: '',
            approvedAmt: 0,
            useCoPay: false,
            isNonCovered: false,
            followDriverCheckIn: false,
            therapyCode: null
        };

        return {
            modalId: 'therapyBillingEditDlgId',
            refresh: false,
            item: this.value
                ? JSON.parse(JSON.stringify(this.value))
                : JSON.parse(JSON.stringify(defaultValue)),
            defaultValue: defaultValue,
            ValCodeFields: ['code', 'shortDescription'],
            isCPTValid: true,
            isValidDate: true,
            posCode: null
        };
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.emitCloseEvent = true;
            }
        },

        value: {
            async handler(newVal) {
                if (newVal) {
                    const converted = await this.convertAIObj(JSON.parse(JSON.stringify(newVal)));
                    this.item = converted;
                    // ✅ Llamar después de asignar
                    await this.getAllDescription();
                } else {
                    this.resetItem();
                }
            },
            deep: true,
            immediate: true
        }
    },

    computed: {
        okDisabled() {
            return !this.validate();
        },

        editMode() {
            return !!this.item.recordId;
        }
    },

    methods: {
        resetItem() {
            this.item = JSON.parse(JSON.stringify(this.defaultValue));
            this.item.pos = this.posCode;
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.$emit('close');
            this.resetItem();
        },

        emitEventOK() {
            const isOverlapping = this.checkOverlapping(this.item);
            this.isValidDate = this.isValidDateRange();
            if (this.validate() && !isOverlapping && this.isValidDate) {
                this.$emit('input', { ...this.item });
                this.$emit('ok');
                this.resetItem();
            } else {
                this.isCPTValid = this.isValid('cpt');

                if (!isOverlapping) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );
                }
                /*if (!this.isValid('billstartDate')) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.invalidMessage('billstartDate'),
                        'errorAutoHide'
                    );
                }
                if (!this.isValid('billendDate')) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.invalidMessage('billendDate'),
                        'errorAutoHide'
                    );
                }*/
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent = false;
                this.resetItem();
            }
        },

        validate() {
            const rules = {
                /*billstartDate: [
                    validationRules.greaterThanDate(
                        Utils.getCurrentDateTime(),
                        'YYYY-MM-DD',
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateLessMsg")
                    ),
                ],
                billendDate: [
                    validationRules.greaterThanDate(
                        Utils.getCurrentDateTime(),
                        'YYYY-MM-DD',
                        this.$t("eItemsReceivedEdit.InvalidExpirationDateLessMsg")
                    ),
                ],*/
                cpt: [validationRules.required('')]
            };

            return this.validateFields(rules, this.item);
        },

        close() {
            this.emitEventCancel();
        },

        ChangeIsActive(item) {
            this.item.status = item.value;
        },
        // Método auxiliar para convertir A/I a booleanos
        async convertAIObj(obj) {
            if (typeof obj !== 'object' || obj === null) return obj;

            if (Array.isArray(obj)) {
                return await Promise.all(obj.map(item => this.convertAIObj(item)));
            }

            const result = {};
            for (const [key, value] of Object.entries(obj)) {
                if (typeof value === 'string' && ['Y'].includes(value)) {
                    result[key] = true;
                } else if (typeof value === 'string' && ['N'].includes(value)) {
                    result[key] = false;
                } else if (typeof value === 'object' && value !== null) {
                    result[key] = await this.convertAIObj(value);
                } else {
                    result[key] = value;
                }
            }
            return result;
        },

        onCodeConditionOk(result) {
            if (!this.item) return;

            const type = result.FieldName;
            const { code, description } = result;

            const mapping = {
                insuranceCode: { codeProp: 'insuranceCode', descProp: 'insuranceName' },
                cpt: { codeProp: 'cpt', descProp: 'dcpt' },
                hcpcs: { codeProp: 'hcPcsCode', descProp: 'dhcpcs' },
                modifiers1: { codeProp: 'modifier1', descProp: 'dmodifier1' },
                modifiers2: { codeProp: 'modifier2', descProp: 'dmodifier2' },
                modifiers3: { codeProp: 'modifier3', descProp: 'dmodifier3' },
                modifiers4: { codeProp: 'modifier4', descProp: 'dmodifier4' },
                valCode: { codeProp: 'valueCode', descProp: 'dvalCode' },
                pos: { codeProp: 'pos', descProp: 'dpos' }
            };

            const key = Object.keys(mapping).find(k => type.includes(k));

            if (key) {
                const { codeProp, descProp } = mapping[key];
                this.item[codeProp] = code || '';
                this.item[descProp] = description || '';
            }
        },

        async getAllDescription() {
            if (!this.item) return;

            const getters = {
                insuranceCode: {
                    codes: [this.item.insuranceCode],
                    fetch: async code => {
                        const response = await InsuranceService.getInsuranceByCode(code);
                        return response?.data.company;
                    },
                    setter: value => {
                        this.$set(this.item, 'insuranceName', value);
                    }
                },
                hcPcsCode: {
                    codes: [this.item.hcPcsCode],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await CptService.getCPTByCode(parameter);
                        return response.data[0]?.name;
                    },
                    setter: value => {
                        this.$set(this.item, 'dhcpcs', value);
                    }
                },
                cpt: {
                    codes: [this.item.cpt],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await CptService.getCPTByCode(parameter);
                        return response.data[0]?.name;
                    },
                    setter: value => {
                        this.$set(this.item, 'dcpt', value);
                    }
                },
                modifier1: {
                    codes: [this.item.modifier1],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await ModifierService.getModifierByCode(parameter);
                        return response.data[0]?.description;
                    },
                    setter: value => {
                        this.$set(this.item, 'dmodifier1', value);
                    }
                },
                modifier2: {
                    codes: [this.item.modifier2],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await ModifierService.getModifierByCode(parameter);
                        return response.data[0]?.description;
                    },
                    setter: value => {
                        this.$set(this.item, 'dmodifier2', value);
                    }
                },
                modifier3: {
                    codes: [this.item.modifier3],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await ModifierService.getModifierByCode(parameter);
                        return response.data[0]?.description;
                    },
                    setter: value => {
                        this.$set(this.item, 'dmodifier3', value);
                    }
                },
                modifier4: {
                    codes: [this.item.modifier4],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await ModifierService.getModifierByCode(parameter);
                        return response.data[0]?.description;
                    },
                    setter: value => {
                        this.$set(this.item, 'dmodifier4', value);
                    }
                },
                valueCode: {
                    codes: [this.item.valueCode],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await ValueCodeService.getValueCodeByCode(parameter);
                        return response.data[0]?.shortDescription;
                    },
                    setter: value => {
                        this.$set(this.item, 'dvalCode', value);
                    }
                },
                pos: {
                    codes: [this.item.pos],
                    fetch: async code => {
                        const parameter = { code: code };
                        const response = await PlaceOfServiceService.getPlaceOfServiceByCode(
                            parameter
                        );
                        return response.data[0]?.description;
                    },
                    setter: value => {
                        this.$set(this.item, 'dpos', value);
                    }
                }
            };

            // Ejecutar todas las peticiones en paralelo
            const promises = Object.values(getters).flatMap(({ codes, fetch, setter }) =>
                codes.filter(Boolean).map(async code => {
                    try {
                        const value = await fetch(code);
                        if (value) {
                            setter(value);
                        } else {
                            console.warn(`No value returned for ${code}`);
                        }
                    } catch (error) {
                        console.error(`Error processing ${code}:`, error);
                        this.showResponseErrorMessage(error);
                    }
                })
            );
            await Promise.allSettled(promises);
        },

        isValidDateRange() {
            if (
                !Utils.isNullOrEmptyString(this.item.startDate) &&
                !Utils.isNullOrEmptyString(this.item.endDate)
            ) {
                return moment(this.item.startDate) <= moment(this.item.endDate);
            }

            return true;
        },

        async getProvider() {
            await ProviderService.ensureVisibleSettings()
                .then(state => {
                    this.posCode = state.providerPosCode;

                    if (!this.value) {
                        this.item.pos = this.posCode;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    created() {
        this.getProvider();
    }
};
</script>
